import {useState} from 'react'
import toast, {Toaster} from 'react-hot-toast'
import {Button} from 'react-bootstrap'
import {useFileUpload} from '../../hooks/useFileUpload'
import {handleApiError} from '../../../helpers/errorHandler'
import {uploadStudents} from './api'
import FileDrop from '../../../components/excelUpload/FileDrop'
import UploadFile from '../../../components/excelUpload/UploadFile'

const StudentUpload = ({onAfterSubmit}: {onAfterSubmit: () => void}) => {
  const [file, setFile] = useState<File | null>(null)
  const [loading, setLoading] = useState(false)

  const {uploadFile, isUploading, uploadProgress} = useFileUpload()

  const submitHandler = async () => {
    setLoading(true)
    let toastId = ''
    try {
      const fileResponse = await uploadFile(file!)

      toastId = toast.loading('Processing data')

      const payload = {file: fileResponse.data}

      await uploadStudents(payload)
      toast.success('Success', {id: toastId})
      onAfterSubmit()
    } catch (error: any) {
      handleApiError(error, toastId)
    } finally {
      setLoading(false)
    }
  }

  return (
    // <div className="d-flex align-items-center flex-column">
    // <div className="fs-1 mb-3 lead">Student Bulk Upload</div>
    <>
      <div className="fv-row card p-6">
        {file ? (
          <UploadFile
            file={file}
            removeFile={() => setFile(null)}
            isUploading={isUploading}
            uploadProgress={uploadProgress}
          />
        ) : (
          <FileDrop
            onDropRejected={() =>
              toast.error(
                'Provided file is not supported. Please upload a file with .xlsx extension.'
              )
            }
            onDropAccepted={(files) => {
              setFile(files[0])
            }}
            templateLink="/excel-template/trip-upload-template-model.xlsx"
            templateFileName="trip-upload-template-model.xlsx"
          />
        )}
        <div className="text-center pt-8">
          <button
            type="reset"
            onClick={() => setFile(null)}
            className="btn btn-light px-8 me-4 border border-gray-200"
            disabled={!file || loading}
          >
            Reset
          </button>
          <Button
            variant="light-success"
            className="pe-3 bg-light-success"
            disabled={file === null || loading}
            onClick={submitHandler}
          >
            <span className="">
              Upload <i className="la la-upload fs-4"></i>
            </span>
          </Button>
        </div>
      </div>
      <Toaster />
    </>
    // </div>
  )
}

export default StudentUpload
